import { ConfigurationGroupType, ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { SelectedExperienceType } from '../types';

export const getSelectableOptions = (
  configGroups: ConfigurationGroupType[],
  experiences: { options: SelectedExperienceType[] }
): ConfigurationGroupOptionType[] => {
  const selectedExperienceOptionIds = experiences.options.map((opt) => opt.optionId);
  const allOptions = configGroups.flatMap((conf) => conf.options);

  return allOptions.filter((option) => selectedExperienceOptionIds.includes(option.id));
};
